import lensProp from "ramda/es/lensProp";
import over from "ramda/es/over";
import view from "ramda/es/view";
const codeLens = lensProp('code');
export const viewCode = view(codeLens);
export const decodeCode = over(lensProp('code'), decodeURIComponent);
